import { FadeUp } from "@/components/Reveal";
import { useLang } from "@/lib/i18n";

const STATS = [
  { n: "16", en: "YEARS", zh: "年历程 · 自 2009", en2: "years since 2009" },
  { n: "40+", en: "SHOWS PRODUCED", zh: "场演出与音乐节", en2: "shows & festivals" },
  { n: "30+", en: "GLOBAL ARTISTS", zh: "位合作国际巨星", en2: "global superstars" },
];

export default function StatsBand() {
  const { lang } = useLang();
  return (
    <section data-testid="stats" className="bg-[#050505] pb-24 md:pb-32">
      <div className="max-w-[1800px] mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {STATS.map((s, i) => (
            <FadeUp key={s.en} delay={i * 0.1} className="bg-[#050505] p-8 md:p-12">
              <div className="font-display text-6xl md:text-7xl text-[#ffde00] leading-none" data-testid={`stat-${s.en.toLowerCase().replace(/\s/g, "-")}`}>
                {s.n}
              </div>
              <div className="font-mono2 text-xs text-[#f5f5f5] tracking-[0.3em] mt-4">{s.en}</div>
              <div className="font-zh text-sm text-[#a1a1aa] mt-1">{lang === "zh" ? s.zh : s.en2}</div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
